module.exports = __webpack_public_path__ + "img/pic11.4eb8a215.png";